import CourseLesson from 'src/model/CourseLesson';
import courseLessonDatabaseMap from 'src/resource/course/CourseLessonDatabaseMap';

export default class CourseLessonRetriever {
  // Get a single course lesson by courseLessonId.
  static async getCourseLesson(courseLessonId?: string): Promise<CourseLesson> {
    if (courseLessonId === undefined) {
      throw Error('courseLessonId undefined.');
    }
    const courseLesson: CourseLesson | undefined = courseLessonDatabaseMap.get(courseLessonId);
    if (courseLesson === undefined) {
      throw Error('CourseLesson not found.');
    }
    return courseLesson;
  }

  // List course lessons with option to filter by courseChapterId.
  static async listCourseLesson(courseChapterId?: string): Promise<Array<CourseLesson>> {
    let courseLessons: Array<CourseLesson> = Array.from(courseLessonDatabaseMap.values());
    if (courseChapterId !== undefined) {
      courseLessons = courseLessons.filter(
        (courseLesson) => courseLesson.courseChapterId === courseChapterId,
      );
    }
    return courseLessons;
  }
}
